import MainLayout from "../components/layout/MainLayout";
import './POC.css';
import {App, Col, ConfigProvider, Row, Space, Table, Tabs, Tag, Typography} from "antd";
import MyVehiclePanel from "../components/panels/MyVehiclePanel";
import PanelFrame from "../components/panels/PanelFrame";
import BannerPanel from "../components/panels/BannerPanel";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {getContracts} from "../api/contracts";
import {showApiError} from "../utility/error/error-handler";

const { Text } = Typography;


// PLEASE NOTE -------------------------------------------------------------
// There are no translations in this demo page. If copying or reusing code,
// please translate button labels and titles and so on as appropriate.
// - see the Login page or the Wiki for examples.
// -------------------------------------------------------------------------


// Vehicle Details
const VehicleDetails = () => {

    return (
        <Row>
            <Col flex="100%">
                <BannerPanel title="Vehicle Details">
                    <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                        <Col><Text className="dp-detail-label">Registration Number</Text></Col>
                        <Col><Text className="dp-detail-label">VIN Number</Text></Col>
                    </Row>
                    <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                        <Col><Text>LR55TYH</Text></Col>
                        <Col><Text>1HD1KHM16D8613457</Text></Col>
                    </Row>
                </BannerPanel>
            </Col>
        </Row>
    );
};

// Allocation History
const allocTableColumns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (text) => <Text>{text}</Text>
    },
    {
        title: 'Age',
        dataIndex: 'age',
        key: 'age',
    },
    {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
    },
    {
        title: 'Tags',
        key: 'tags',
        dataIndex: 'tags',
        render: (_, { tags }) => (
            <>
                {tags.map((tag) => {
                    let color = tag.length > 5 ? 'geekblue' : 'green';
                    if (tag === 'loser') {
                        color = 'volcano';
                    }
                    return (
                        <Tag color={color} key={tag}>
                            {tag.toUpperCase()}
                        </Tag>
                    );
                })}
            </>
        ),
    },
    {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                Invite {record.name}
                Delete
            </Space>
        ),
    },
];
const allocTableDummyData = [
    {
        key: '1',
        name: 'John Brown',
        age: 32,
        address: 'New York No. 1 Lake Park',
        tags: ['nice', 'developer'],
    },
    {
        key: '2',
        name: 'Jim Green',
        age: 42,
        address: 'London No. 1 Lake Park',
        tags: ['loser'],
    },
    {
        key: '3',
        name: 'Joe Black',
        age: 32,
        address: 'Sydney No. 1 Lake Park',
        tags: ['cool', 'teacher'],
    },
];
const AllocationHistoryTable = () => {

    return (
        <Row>
            <Col flex="100%">
                <BannerPanel title="Allocation History">
                    <Table columns={allocTableColumns} dataSource={allocTableDummyData} />
                </BannerPanel>
            </Col>
        </Row>
    );
};


// Tab Structure
const vehicleProfileTabs = [
    {
        key: 'details',
        label: 'Vehicle Details',
        children: <VehicleDetails />,
    },
    {
        key: 'alloc',
        label: 'Allocation History',
        children: <AllocationHistoryTable />,
    },
    {
        key: 'contract',
        label: 'Contract and Services',
        children: <></>,
    },
    {
        key: 'finance',
        label: 'Financials',
        children: <></>,
    },
    {
        key: 'fines',
        label: 'Fines and Offences',
        children: <></>,
    },
    {
        key: 'maint',
        label: 'Maintenance History',
        children: <></>,
    },
    {
        key: 'accident',
        label: 'Accident History',
        children: <></>,
    },
    {
        key: 'carbon',
        label: 'Carbon Reporting',
        children: <></>,
    },
];

// MAIN COMPONENT
const POC2 = () => {

    const { t } = useTranslation();
    const { notification } = App.useApp();
    // const [vehicle, setVehicle] = useState(null);

    const [contracts, setContracts] = useState([]);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        getContracts()
            .then(res => {
                // setLoading(false);
                setContracts(res);
                if(res.length > 0)
                {
                    // setVehicle(res[0].contractVehicle);
                }}, )
            .catch(err => showApiError(t('title.my_vehicles'), err, notification));
    }, [t, notification]);

    // Tabs Control
    const onTabChange = (key) => {
        console.log(key);
    };

    return (
        <MainLayout showSubHeader={true} startHigher="200px" subHeaderContent={<MyVehiclePanel contracts={contracts}  onChange={(vehicle) => {console.log(vehicle);}}/>} footerShowReturnToTop={false}>
            <Row>
                <Col flex="100%">
                    {/*Vehicle Details Snapshot*/}
                    <PanelFrame title="Vehicle Profile">
                        <Row style={{ width: '100%' }}>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Tabs: {
                                            /* design tokens */
                                            horizontalItemGutter: 20,
                                            inkBarColor: 'transparent',
                                            horizontalMargin: '0 0 -10px 10px'
                                        },
                                    },
                                }}  //ant-tabs-nav
                            >
                                <Tabs style={{ width: '100%', minHeight: '300px' }}
                                      onChange={onTabChange}
                                      type="line"
                                      size="medium"
                                      items={vehicleProfileTabs} />
                            </ConfigProvider>
                        </Row>
                    </PanelFrame>
                </Col>
            </Row>
        </MainLayout>
    );
}

export default POC2;